import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import InfiniteScroll from "react-infinite-scroll-component";
import { useHistory } from "react-router";
import { ADMINS_COLLECTION } from "../../constants";
import db from "../../firebaseConfig";
import LoadingIndicator from "../layouts/LoadingIndicator";

const AdminPage = () => {

    const [admins, setAdmins] = useState([]);
    const [lastDocId, setLastDocId] = useState(null);
    const [hasMore, setHasMore] = useState(true);

    const history = useHistory();
    
    useEffect(() => {
        if(admins.length === 0) {
            return getData();
        }
    }, []);

    const getData = async () => await db.collection(ADMINS_COLLECTION)
            .orderBy('createdAt','desc').limit(15).get()
            .then((collections) => updateState(collections));

    const fetchTopupsData = async () => {
        if(lastDocId) {
            return await db.collection(ADMINS_COLLECTION)
            .orderBy('createdAt','desc')
            .startAfter(lastDocId)
            .limit(15)
            .get()
            .then((collections) => {
                updateState(collections);
            });
        }
    }

    const updateState = (collections) => {
        const isCollectionsEmpty = collections.size === 0;
    
        if(!isCollectionsEmpty) {
    
            const adminsData = collections.docs.map((doc) => {
                return {
                    uid: doc?.id,
                    displayName: doc.data()?.displayName,
                    email: doc.data()?.email,
                    status: doc.data()?.status,
                    type: doc.data()?.type,
                    phoneNumber: doc.data()?.phoneNumber,
                    photoURL: doc.data()?.photoURL,
                    createdAt: doc.data()?.createdAt,
                    updatedAt: doc.data()?.updatedAt,
                };
            });
    
            const docId = collections.docs[collections.docs.length - 1];
            setAdmins((admins) => [...admins, ...adminsData]);
            setLastDocId(docId);
        } else {
            setHasMore(false);
        }
    }

    const toggleStatus = async (admin,index) => {
        // console.log(admins);
        if(admin.type === 'admin') {
            await db.collection(ADMINS_COLLECTION).doc(admin.uid).update({type: null});
            // getDiamonds();
            let updatedData = admins.map((admin, i) => {
                if(i===index) {
                    admin.type = null;
                    return  admin;
                } else return admin;
            });
            setAdmins(updatedData);
            return toast.success('Success', {position: 'bottom-center', className: 'backdrop-filter backdrop-blur-lg bg-opacity-20',id: 'clipboard',});
        } else if(admin.type !== 'super-admin' && admin.type !== 'admin') {
            await db.collection(ADMINS_COLLECTION).doc(admin.uid).update({type: 'admin'});
            // getDiamonds();
            let updatedData = admins.map((admin, i) => {
                if(i===index) {
                    admin.type = 'admin';
                    return  admin;
                } else return admin;
            });
            setAdmins(updatedData);
            return toast.success('Success', {position: 'bottom-center', className: 'backdrop-filter backdrop-blur-lg bg-opacity-20',id: 'clipboard',});
        } else {
            return toast.error('Access Denied!', {position: 'bottom-center', className: 'backdrop-filter backdrop-blur-lg bg-opacity-20',id: 'clipboard',});
        }
    }

    return (
        <div className="min-h-screen">
            <div className="flex w-full justify-between bg-blue-400 py-4 px-4 backdrop-filter backdrop-blur-lg bg-opacity-20 overflow-hidden shadow">
                <button onClick={() => history.goBack()} className=" text-gray-200">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16l-4-4m0 0l4-4m-4 4h18" />
                    </svg>
                </button>
                <p className="m-auto inset-0 text-xl font-semibold leading-7 text-center text-gray-200">All Admin List</p>
            </div>
            <div className="">
                <InfiniteScroll
                    dataLength={admins.length} //This is important field to render the next data
                    next={fetchTopupsData}
                    hasMore={hasMore}
                    style={{height: 'unset', overflow: 'unset'}}
                    loader={<LoadingIndicator/>}
                    endMessage={
                        <p className="text-gray-500 mt-2" style={{ textAlign: 'center' }}>
                        <b>Yay! You have seen it all</b>
                        </p>
                    }
                    >
                    <div className="flex justify-center items-center mt-10">
                        <div className="space-y-4 w-full md:w-1/2 lg:w-1/2 px-4">
                        {   admins.map((admin, index) => {
                                    return (
                                        <div key={index} className="flex w-full justify-start items-center p-4 bg-blue-400 rounded-xl shadow-lg hover:shadow-xl transform transition duration-500 backdrop-filter backdrop-blur-lg bg-opacity-20 rounded-xl overflow-hidden shadow-lg">
                                            <img className="w-1/8 h-12 md:h-16  object-cover rounded-full" src={admin.photoURL} alt="" />
                                            <div className="w-6/8 flex flex-col justify-start px-3">
                                                <div>
                                                    {(admin.type === 'admin' || admin.type === 'super-admin') ? (<span className="bg-green-600 text-white py-1 text-xs uppercase px-3 rounded-full backdrop-filter backdrop-blur-lg bg-opacity-40">{admin.type}</span>) : (<span className="bg-green-600 text-gray-400 py-1 text-xs uppercase px-3 rounded-full backdrop-filter backdrop-blur-lg bg-opacity-20 ml-3">None</span>)}
                                                </div>
                                                <p className="text-2xl text-gray-300">
                                                    <span>{admin.displayName}</span>
                                                </p>
                                                <p className="text-gray-400">{admin.email}</p>
                                                <p className="text-gray-500 text-xs">{new Date(admin.createdAt.toDate()).toDateString()}</p>
                                            </div>
                                            <div className="w-1/8 flex justify-center w-full">
                                                {(admin.type !== 'super-admin') && (<label className="flex items-center relative w-max cursor-pointer select-none">
                                                    <input onChange={() => toggleStatus(admin, index)} checked={(admin.type === 'admin') ? true : false} type="checkbox" className="appearance-none transition-colors cursor-pointer w-14 h-7 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-black focus:ring-green-500 bg-red-500" />
                                                    <span className="absolute font-medium text-xs uppercase right-1 text-white"> OFF </span>
                                                    <span className="absolute font-medium text-xs uppercase right-8 text-white"> ON </span>
                                                    <span className="w-7 h-7 right-7 absolute rounded-full transform transition-transform bg-gray-200" />
                                                </label>)}
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </div>
                </InfiniteScroll>
            </div>
        </div>
    );
}

export default AdminPage;